export enum MergeStudentPanelType {
  NONE = '',
  NEW = 'New',
  CURRENT = 'Current',
  EXISTING = 'Existing',
}
